var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('views.home.title'),expression:"'views.home.title'"}],staticClass:"mt-0"})])}
var staticRenderFns = []

export { render, staticRenderFns }